export default __webpack_public_path__ + "static/media/Gallery - Edition II vs IV - 2_00.3249bd26.jpg";